import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { theme } from '../../../assets/styles/theme';
import { TextMain } from '../../typography/Texts';
import { makeTransparentColor } from '../../../assets/styles/transparentColor';

const Container = styled.div`
  display: flex;
  background-color: ${theme.color.lighterGray};
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  border-radius: 5px;
  height: 26px;
  padding: 0 12px;
  margin-top: 5px;
`;

const ResignedText = styled(TextMain)`
  color: ${makeTransparentColor(theme.color.black, 0.9)};
`;

const ResignedBadge = () => {
  const { t } = useTranslation('onsite');

  return (
    <Container>
      <ResignedText>{t('bids.resigned')}</ResignedText>
    </Container>
  );
};

export default ResignedBadge;
